import { NoteInfo } from './types'

export const viewNoteHistory = <T extends Record<string, unknown>>(note: NoteInfo<T>) => {
	console.log('View note history, TODO:', note)
}
